import { icons as editor_icons } from "~/custom/tinymce/icons/editor_icons";

tinymce.IconManager.add('a51icons', {
  icons: editor_icons,
});
